"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stripUndefined = _interopRequireDefault(require("./strip-undefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultOptions = {
  encode: true,
  prefix: '?'
};

var getOptionsToUse = function getOptionsToUse(options) {
  // NOTE: For backwards compatibility with previous API
  if (typeof options === 'boolean') {
    return Object.assign({}, defaultOptions, {
      encode: options
    });
  }

  return Object.assign({}, defaultOptions, (0, _stripUndefined["default"])(options));
};

function toQueryString(queryObject) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var optionsToUse = getOptionsToUse(options);
  return Object.keys(queryObject).filter(function (key) {
    return queryObject[key] !== undefined;
  }).reduce(function (accumulator, currentKey, currentIndex) {
    var currentValue = queryObject[currentKey];

    if (currentValue !== undefined) {
      var separator = currentIndex === 0 ? optionsToUse.prefix : '&';

      var _ref = optionsToUse.encode ? [encodeURIComponent(currentKey), encodeURIComponent(currentValue)] : [currentKey, currentValue],
          _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      accumulator = "".concat(accumulator).concat(separator).concat(key, "=").concat(value);
    }

    return accumulator;
  }, '');
}

var _default = toQueryString;
exports["default"] = _default;